module.exports = __webpack_public_path__ + "static/img/1000000514_red.cf4de6a8.jpg";